import QRCode from 'qrcode';
import html2canvas from 'html2canvas';

const LOGO_URL = 'https://i.ibb.co/Mk38h577/logo.png';

export async function composeQrCodePng({ payload, topLabel, bottomLabel } = {}) {
  if (!payload) {
    throw new Error('composeQrCodePng: payload is required');
  }

  const qrCodeDataUrl = await QRCode.toDataURL(JSON.stringify(payload), {
    errorCorrectionLevel: 'H',
    type: 'image/png',
    width: 250,
    margin: 1,
  });

  const tempContainer = document.createElement('div');
  tempContainer.style.cssText = `
    background-color: black;
    color: white;
    padding: 20px;
    border-radius: 15px;
    display: inline-block;
    text-align: center;
    position: absolute;
    left: -9999px;
    top: -9999px;
  `;

  if (topLabel) {
    const top = document.createElement('p');
    top.textContent = topLabel;
    top.style.cssText = `
      margin-bottom: 12px;
      font-size: 1.4em;
      font-weight: 600;
      font-family: 'Courier New', Courier, monospace;
    `;
    tempContainer.appendChild(top);
  }

  const qrWrapper = document.createElement('div');
  qrWrapper.style.cssText = `
    position: relative;
    background: white;
    padding: 12px;
    border-radius: 8px;
    display: inline-block;
  `;

  const qrImage = document.createElement('img');
  qrImage.src = qrCodeDataUrl;
  qrImage.style.cssText = `
    display: block;
    width: 250px;
    height: 250px;
  `;

  const logoImage = document.createElement('img');
  logoImage.src = LOGO_URL;
  logoImage.style.cssText = `
    position: absolute;
    width: 60px;
    height: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `;

  qrWrapper.appendChild(qrImage);
  qrWrapper.appendChild(logoImage);
  tempContainer.appendChild(qrWrapper);

  if (bottomLabel) {
    const bottom = document.createElement('p');
    bottom.textContent = bottomLabel;
    bottom.style.cssText = `
      margin-top: 15px;
      font-size: 2em;
      font-weight: 700;
      font-family: 'Courier New', Courier, monospace;
    `;
    tempContainer.appendChild(bottom);
  }

  document.body.appendChild(tempContainer);

  try {
    const canvas = await html2canvas(tempContainer, {
      backgroundColor: null,
      scale: 3,
      useCORS: true,
    });
    return canvas.toDataURL('image/png');
  } finally {
    document.body.removeChild(tempContainer);
  }
}
